import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { ConfigurationsService } from '@epicuro-next/platform/configuration';
import { selectActiveBasketId } from '@epicuro-next/state/basket-state';
import {
  clearPaginationData,
  selectAllBasketsLoaded,
  selectIsBasketSwitching,
  selectManagerLoading,
} from '@epicuro-next/state/basket-switch-state';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { delay, filter, shareReplay } from 'rxjs/operators';

import {
  BasketManagerConfigurationKeys,
  BasketManagerConfigurations,
  BASKET_MANAGER_FEATURE_NAME,
  DEFAULT_IS_GROUPED_VIEW,
} from '../../configurations';

@Component({
  selector: 'epc-switch-basket',
  templateUrl: './switch-basket.component.html',
  styleUrls: ['./switch-basket.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SwitchBasketComponent implements OnInit {
  @HostBinding('class') public hostDisplay = 'd-flex flex-column';

  public isGroupedView$: Observable<boolean> =
    this.configsService.getConfigValue<
      BasketManagerConfigurations,
      BasketManagerConfigurationKeys.IsGroupedView
    >({
      namespace: BASKET_MANAGER_FEATURE_NAME,
      featureName: BasketManagerConfigurationKeys.IsGroupedView,
      defaultValue: DEFAULT_IS_GROUPED_VIEW,
    });

  public loading$ = this.store.pipe(
    select(selectManagerLoading),
    // loader changed by action triggered from child component during CD
    // delay for start cd
    delay(0),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  public activeBasketId$ = this.store.pipe(
    select(selectActiveBasketId),
    filter((basketId) => !!basketId),
  );

  public isSwitching$ = this.store.pipe(select(selectIsBasketSwitching));

  public allLoaded$ = this.store.pipe(select(selectAllBasketsLoaded));
  public searchTerm?: string;

  constructor(
    private store: Store,
    private configsService: ConfigurationsService,
  ) {}

  public ngOnInit() {
    this.store.dispatch(clearPaginationData());
  }

  public searchBasket(term?: string) {
    this.store.dispatch(clearPaginationData());
    this.searchTerm = term;
  }
}
